"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const formik_1 = require("formik");
const react_2 = require("react");
const getAtom_1 = __importDefault(require("../../../data/utilities/getAtom"));
const ChartContext_1 = require("../../context/ChartContext");
const MoleculeSelection_1 = __importDefault(require("../../elements/MoleculeSelection"));
const styles = (0, react_1.css) `
  .molecule-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    .title {
      padding: 0 10px;
      width: 100%;
      text-align: center;
    }

    .molecule-selection-container {
      width: 450px;
      display: block;
      margin: 0 auto;
    }

    .new-sum-text {
      margin-top: 15px;
      padding: 0 10px;
      width: 100%;
      text-align: center;
    }
  }

  .empty {
    width: 100%;
    padding: 20%;
    text-align: center;
  }
`;
function SelectMolecule(props) {
    const [currentIndex, setCurrentIndex] = (0, react_2.useState)();
    const { setFieldValue, errors, values } = (0, formik_1.useFormikContext)();
    const { molecules, view: { spectra: { activeTab }, }, } = (0, ChartContext_1.useChartData)();
    const element = (0, getAtom_1.default)(activeTab);
    const newSum = (0, react_2.useMemo)(() => {
        return element &&
            molecules &&
            molecules.length > 0 &&
            currentIndex !== undefined &&
            molecules[currentIndex].atoms[element]
            ? molecules[currentIndex].atoms[element]
            : 0;
    }, [currentIndex, element, molecules]);
    const setValue = (0, react_2.useCallback)((index) => {
        setCurrentIndex(index);
        void setFieldValue(props.name, molecules[index]);
    }, [molecules, props.name, setFieldValue]);
    (0, react_2.useEffect)(() => {
        if (molecules && molecules.length > 0) {
            const index = values[props.name]
                ? molecules.findIndex((molecule) => molecule.id === values[props.name].id)
                : -1;
            setValue(index !== -1 ? index : 0);
        }
    }, [molecules, props.name, setValue, values]);
    const onChangeMoleculeSelectionHandler = (0, react_2.useCallback)((index) => {
        setValue(index);
    }, [setValue]);
    return ((0, jsx_runtime_1.jsx)("div", { css: styles, children: element && molecules && molecules.length > 0 ? ((0, jsx_runtime_1.jsxs)("div", { className: "molecule-container", children: [(0, jsx_runtime_1.jsx)("p", { className: "title", children: "Select a molecule as reference!" }), (0, jsx_runtime_1.jsxs)("div", { className: "molecule-selection-container", children: [(0, jsx_runtime_1.jsx)(MoleculeSelection_1.default, { index: currentIndex, molecules: molecules, onChange: onChangeMoleculeSelectionHandler }), (0, jsx_runtime_1.jsxs)("p", { className: "new-sum-text", children: ["New sum for ", element, " will be ", newSum, "!"] })] })] })) : ((0, jsx_runtime_1.jsx)("p", { className: "empty", style: { color: errors[props.name] ? 'red' : 'black' }, children: "You have to Select a spectrum and Add a molecule from the Structure panel to select as a reference!" })) }));
}
exports.default = SelectMolecule;
